'use strict';

var logObject = {};
['log', 'debug', 'warn'].forEach(function (level) {
  var levelExists = global.console && global.console[level] && global.console[level].apply;
  logObject[level] = levelExists ? function () {
    return global.console[level].apply(global.console, arguments);
  } : (level === 'log' ? function () {} : logObject.log);
});

module.exports = logObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/utils/log.js
 ** module id = 308
 ** module chunks = 0
 **/